import { Operation } from "components/Car/types";

import { TranslationKeys } from "types/locale";

import { CarPart } from "./CarPart";

export type CostBreakdown = {
  partsTotal?: string;
  labourTotal?: string;
  paintTotal?: string;
  deductible: string | null;
};

export const COST_BREAKDOWN_LABELS: Record<keyof CostBreakdown, TranslationKeys> = {
  partsTotal: "estimate.parts_price",
  labourTotal: "estimate.labour_price",
  paintTotal: "estimate.paint_price",
  deductible: "estimate.deductible",
} as const;

export type Estimate = {
  totalIncludingTax: string;
  totalExcludingTax: string;
  breakdown: CostBreakdown;
  damagedParts: Partial<Record<CarPart, {
    operation: Operation,
    replacementPartCost?: string | null
  }>>;
  hasInternalDamage: boolean;
  isEstimateDisplayEnabled: boolean;
  isInScope: boolean;
  isTotalLoss: boolean;
  isSpeedyPaymentEnabled: boolean;
};
